import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class RequisitionAutoSaveDispatcherService {
  public save$: Observable<void>;
  public allowChangeTab$: Observable<boolean>;

  private _save$ = new Subject<void>();
  private _allowChangeTab$ = new Subject<boolean>();

  constructor() {
    this.save$ = this._save$.asObservable();
    this.allowChangeTab$ = this._allowChangeTab$.asObservable();
  }

  public save() {
    this._save$.next();
  }

  public allowChangeTab(saved: boolean) {
    this._allowChangeTab$.next(saved);
  }
}
